/*
 * documentSets reducer
 */
import get from 'lodash.get';

import { RESET_STATE } from '../auth/constants';
import {
    DOCUMENT_SETS_SET,
    DOCUMENT_SETS_MERGE,
    DOCUMENT_SET_SET
} from './constants';

type State = {
    [string]: Object
};

type Action = {
    +type: string,
    +payload: Object
};

const initialState = {};

export default function(state: State = initialState, action: Action) {
    switch (action.type) {
        case DOCUMENT_SETS_SET:
            return get(action, 'payload.entities.documentSets', {});
        case DOCUMENT_SETS_MERGE: {
            const documentSets = get(
                action,
                'payload.entities.documentSets',
                {}
            );
            return {
                ...state,
                ...documentSets
            };
        }
        case DOCUMENT_SET_SET:
            return {
                ...state,
                [action.payload.id]: action.payload
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
